import React, { useEffect, useState } from "react";

import { Marker, InfoWindow } from "@react-google-maps/api";

import { defaultMarker, greenMark } from "../Icons";
import { formatMapData, handleCenter } from "../../helpers";
import { useTranslation } from "react-i18next";

const options = {
  imagePath:
    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
};

const BaseMarker = ({
  data,
  categoryId,
  openInfoWindow,
  selectedItem,
  center,
  zoomLevel,
  rightSideBox,
}) => {
  const [MarkerData, setMarkerData] = useState(null);
  const [activeMarkerId, setActiveMarkerId] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const tempData = formatMapData(categoryId, data, false, t);
    setMarkerData(tempData);

    return () => {
      setMarkerData(null);
    };
  }, [data]);

  useEffect(() => {
    if (selectedItem.getItem) {
      center.set({
        lat:
          categoryId === "24"
            ? selectedItem?.getItem.Lat
            : parseFloat(
                selectedItem?.getItem?.latitude ?? selectedItem?.getItem?.lat
              ),
        lng:
          categoryId === "24"
            ? selectedItem?.getItem.Lon
            : parseFloat(
                selectedItem?.getItem?.longitude ?? selectedItem?.getItem?.lng
              ),
      });
      zoomLevel.set(21);
      setActiveMarkerId(
        selectedItem?.getItem?.id ?? selectedItem?.getItem?.mysensor_id
      );
      openInfoWindow.set(true);
    } else {
      center.set(handleCenter(categoryId, {}));
      zoomLevel.set(15);
    }
  }, [selectedItem.getItem]);

  return (
    <Marker
      noRedraw={true}
      title={MarkerData?.title}
      key={`${categoryId}_marker_${MarkerData?.id ?? MarkerData?.mysensor_id}`}
      position={MarkerData?.position}
      clickable
      icon={MarkerData?.icon}
      onClick={() => {
        openInfoWindow.set(true);

        selectedItem.setItem(data);
        center.set(MarkerData?.position);
        zoomLevel.set(21);
        if (
          categoryId === "1" ||
          categoryId === "10" ||
          categoryId === "31" ||
          categoryId === "7" ||
          categoryId === "30" ||
          categoryId === "24" ||
          categoryId === "8"
        ) {
          if (!rightSideBox.isVisible) {
            rightSideBox.setIsVisible(!rightSideBox.isVisible);
          }
        }
        setActiveMarkerId(MarkerData?.id ?? MarkerData?.mysensor_id);
      }}
    >
      {openInfoWindow.get && activeMarkerId === MarkerData.id && (
        <InfoWindow
          position={
            MarkerData?.position ?? {
              lat: parseFloat(MarkerData?.lat),
              lng: parseFloat(MarkerData?.lng),
            }
          }
          onCloseClick={() => {
            openInfoWindow.set(false);
            center.set(handleCenter(categoryId, {}));
          }}
        >
          <div style={{ width: "fit-content", paddingInline: "30px" }}>
            <p>{MarkerData?.title}</p>
            <p>{MarkerData?.subTitle}</p>
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
};

export default BaseMarker;
